import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducer from './redux/reducers';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
const store = createStore(reducer);

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
let deviceid = localStorage.getItem("deviceId");
let token = localStorage.getItem("token");
if (deviceid && token) {
  axios.defaults.headers.common['deviceid'] = deviceid;
  axios.defaults.headers.common['token'] = token;
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// === Loader functions ===
const showLoader = () => {
  // Trigger your loading state here, e.g., set a loading variable to true or show a spinner
  document.body.classList.add('loading'); // Example
};

const hideLoader = () => {
  document.body.classList.remove('loading'); // Example
};

// === Axios Interceptors ===

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    showLoader();
    return config;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

// Response interceptor
axios.interceptors.response.use(
  (response) => {
    hideLoader();
    return response;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
